export default "__VITE_ASSET__C4LkxGSr__"